module.exports = __webpack_public_path__ + "static/media/CSM.49d9c67a.svg";